var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import axios from 'axios';
import { YURL } from 'yurl';
import { isEmail } from '@ackreditering/validators';
const apiBaseUrl = new YURL(process.env.NEXT_PUBLIC_API_BASE_URL || '').pathname('api/accounts/');
export const sendPasswordResetEmail = (passwordReset) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    try {
        const options = {
            timeout: 10000,
            data: passwordReset,
            url: apiBaseUrl.clone().pathname('password/email').format(),
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        const response = yield axios(options);
        const { status, data } = response;
        if (data != null && status >= 200 && status < 300) {
            return {
                success: true,
            };
        }
        else {
            return {
                success: false,
                statusCode: status,
                errorMessageCode: data.errorMessageCode,
                collision: data.collision,
            };
        }
    }
    catch (e) {
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            console.log('Axios error. Response Status:', (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.status, ' Data:', (_b = axiosError.response) === null || _b === void 0 ? void 0 : _b.data);
            return {
                success: false,
                statusCode: (_c = axiosError.response) === null || _c === void 0 ? void 0 : _c.status,
                errorMessageCode: (_f = (_e = (_d = axiosError.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.errorMessageCode) !== null && _f !== void 0 ? _f : 'error.send.failed',
                collision: (_j = (_h = (_g = axiosError.response) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.collision) !== null && _j !== void 0 ? _j : false,
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.send.failed',
        };
    }
});
export const performPasswordReset = (passwordResetRequest) => __awaiter(void 0, void 0, void 0, function* () {
    var _k, _l, _m, _o, _p, _q, _r, _s, _t;
    try {
        const options = {
            timeout: 10000,
            data: passwordResetRequest,
            url: apiBaseUrl.clone().pathname('password/reset').format(),
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        const response = yield axios(options);
        const { status, data } = response;
        return {
            success: status >= 200 && status < 300 && (data === null || data === void 0 ? void 0 : data.success),
        };
    }
    catch (e) {
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            console.log('Axios error. Response Status:', (_k = axiosError.response) === null || _k === void 0 ? void 0 : _k.status, ' Data:', (_l = axiosError.response) === null || _l === void 0 ? void 0 : _l.data);
            return {
                success: false,
                statusCode: (_m = axiosError.response) === null || _m === void 0 ? void 0 : _m.status,
                errorMessageCode: (_q = (_p = (_o = axiosError.response) === null || _o === void 0 ? void 0 : _o.data) === null || _p === void 0 ? void 0 : _p.errorMessageCode) !== null && _q !== void 0 ? _q : 'error.failed',
                collision: (_t = (_s = (_r = axiosError.response) === null || _r === void 0 ? void 0 : _r.data) === null || _s === void 0 ? void 0 : _s.collision) !== null && _t !== void 0 ? _t : false,
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.failed',
        };
    }
});
export const getAccountInfos = (trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _u, _v, _w, _x, _y, _z, _0, _1, _2;
    try {
        const options = {
            timeout: 10000,
            data: '',
            url: apiBaseUrl.format(),
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        const response = yield axios(options);
        const { status, data } = response;
        if (data != null && status >= 200 && status < 300) {
            return {
                success: true,
                data: data.data.map((u) => (Object.assign(Object.assign({}, u), { crewApprovalDate: u.crewApprovalDate
                        ? new Date(u.crewApprovalDate)
                        : undefined, pressApprovalDate: u.pressApprovalDate
                        ? new Date(u.pressApprovalDate)
                        : undefined, createdAt: u.createdAt ? new Date(u.createdAt) : new Date() }))),
            };
        }
        else {
            return {
                success: false,
                statusCode: status,
                errorMessageCode: data.errorMessageCode,
                collision: data.collision,
            };
        }
    }
    catch (e) {
        trackException(new Error(`Failed to get accounts. ${e}`));
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            console.log('Axios error. Response Status:', (_u = axiosError.response) === null || _u === void 0 ? void 0 : _u.status, ' Data:', (_v = axiosError.response) === null || _v === void 0 ? void 0 : _v.data);
            return {
                success: false,
                statusCode: (_w = axiosError.response) === null || _w === void 0 ? void 0 : _w.status,
                errorMessageCode: (_z = (_y = (_x = axiosError.response) === null || _x === void 0 ? void 0 : _x.data) === null || _y === void 0 ? void 0 : _y.errorMessageCode) !== null && _z !== void 0 ? _z : 'error.fetch.failed',
                collision: (_2 = (_1 = (_0 = axiosError.response) === null || _0 === void 0 ? void 0 : _0.data) === null || _1 === void 0 ? void 0 : _1.collision) !== null && _2 !== void 0 ? _2 : false,
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.fetch.failed',
        };
    }
});
export const getFullAccounts = (options, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _3, _4, _5, _6, _7, _8, _9, _10, _11;
    try {
        const reqOptions = {
            timeout: 10000,
            data: '',
            url: apiBaseUrl
                .clone()
                .pathname('full')
                .query(Object.assign(Object.assign({}, (options.filter ? { filter: options.filter } : {})), (options.onlyManagedAreas ? { onlyManagedAreas: 'true' } : {})))
                .format(),
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        const response = yield axios(reqOptions);
        const { status, data } = response;
        if (data != null && status >= 200 && status < 300) {
            return {
                success: true,
                data: data.data.map((a) => {
                    const account = Object.assign(Object.assign({}, a), { createdAt: a.createdAt ? new Date(a.createdAt) : new Date() });
                    if (account.crew) {
                        if (account.crew.approvedBy) {
                            account.crew.approvedBy.date = new Date(account.crew.approvedBy.date);
                        }
                        if (account.crew.rejectedBy) {
                            account.crew.rejectedBy.date = new Date(account.crew.rejectedBy.date);
                        }
                        if (account.crew.details) {
                            account.crew.details.canWorkDates = account.crew.details
                                .canWorkDates
                                ? account.crew.details.canWorkDates.map((d) => new Date(d))
                                : [];
                            account.crew.details.gdprConsentDate = account.crew.details
                                .gdprConsentDate
                                ? new Date(account.crew.details.gdprConsentDate)
                                : undefined;
                        }
                    }
                    if (account.press) {
                        if (account.press.approvedBy) {
                            account.press.approvedBy.date = new Date(account.press.approvedBy.date);
                        }
                        if (account.press.rejectedBy) {
                            account.press.rejectedBy.date = new Date(account.press.rejectedBy.date);
                        }
                        if (account.press.details) {
                            account.press.details.gdprConsentDate = account.press.details
                                .gdprConsentDate
                                ? new Date(account.press.details.gdprConsentDate)
                                : undefined;
                        }
                    }
                    return account;
                }),
            };
        }
        return {
            success: false,
            statusCode: status,
            errorMessageCode: data.errorMessageCode,
            collision: data.collision,
        };
    }
    catch (e) {
        console.log('>', e);
        trackException(new Error(`Failed to get accounts. ${e}`));
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            console.log('Axios error. Response Status:', (_3 = axiosError.response) === null || _3 === void 0 ? void 0 : _3.status, ' Data:', (_4 = axiosError.response) === null || _4 === void 0 ? void 0 : _4.data);
            return {
                success: false,
                statusCode: (_5 = axiosError.response) === null || _5 === void 0 ? void 0 : _5.status,
                errorMessageCode: (_8 = (_7 = (_6 = axiosError.response) === null || _6 === void 0 ? void 0 : _6.data) === null || _7 === void 0 ? void 0 : _7.errorMessageCode) !== null && _8 !== void 0 ? _8 : 'error.fetch.failed',
                collision: (_11 = (_10 = (_9 = axiosError.response) === null || _9 === void 0 ? void 0 : _9.data) === null || _10 === void 0 ? void 0 : _10.collision) !== null && _11 !== void 0 ? _11 : false,
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.fetch.failed',
        };
    }
});
export const getAccount = (id, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _12, _13, _14, _15, _16, _17, _18, _19, _20;
    try {
        if (!id) {
            return {
                success: false,
                errorMessageCode: 'error.data.format',
            };
        }
        const apiUrl = apiBaseUrl.clone().pathname(id);
        const options = {
            timeout: 10000,
            data: '',
            url: apiUrl.format(),
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        const response = yield axios(options);
        const { status, data } = response;
        if (status >= 200 && status < 300 && (data === null || data === void 0 ? void 0 : data.success)) {
            return {
                success: true,
                data: data.data,
            };
        }
        else {
            return {
                success: false,
                statusCode: status,
                errorMessageCode: data.errorMessageCode,
                collision: data.collision,
            };
        }
    }
    catch (e) {
        trackException(new Error(`Failed to get full account. ${e}`));
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            console.log('Axios error. Response Status:', (_12 = axiosError.response) === null || _12 === void 0 ? void 0 : _12.status, ' Data:', (_13 = axiosError.response) === null || _13 === void 0 ? void 0 : _13.data);
            return {
                success: false,
                statusCode: (_14 = axiosError.response) === null || _14 === void 0 ? void 0 : _14.status,
                errorMessageCode: (_17 = (_16 = (_15 = axiosError.response) === null || _15 === void 0 ? void 0 : _15.data) === null || _16 === void 0 ? void 0 : _16.errorMessageCode) !== null && _17 !== void 0 ? _17 : 'error.fetch.failed',
                collision: (_20 = (_19 = (_18 = axiosError.response) === null || _18 === void 0 ? void 0 : _18.data) === null || _19 === void 0 ? void 0 : _19.collision) !== null && _20 !== void 0 ? _20 : false,
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.fetch.failed',
        };
    }
});
export const getFullAccount = (id, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _21, _22, _23, _24, _25, _26, _27, _28, _29;
    try {
        if (!id) {
            return {
                success: false,
                errorMessageCode: 'error.data.format',
            };
        }
        const apiUrl = apiBaseUrl.clone().pathname(`${id}/full`);
        const options = {
            timeout: 10000,
            data: '',
            url: apiUrl.format(),
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        const response = yield axios(options);
        const { status, data } = response;
        if (status >= 200 && status < 300 && (data === null || data === void 0 ? void 0 : data.success)) {
            return {
                success: true,
                data: data.data,
            };
        }
        else {
            return {
                success: false,
                statusCode: status,
                errorMessageCode: data.errorMessageCode,
                collision: data.collision,
            };
        }
    }
    catch (e) {
        trackException(new Error(`Failed to get full account. ${e}`));
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            console.log('Axios error. Response Status:', (_21 = axiosError.response) === null || _21 === void 0 ? void 0 : _21.status, ' Data:', (_22 = axiosError.response) === null || _22 === void 0 ? void 0 : _22.data);
            return {
                success: false,
                statusCode: (_23 = axiosError.response) === null || _23 === void 0 ? void 0 : _23.status,
                errorMessageCode: (_26 = (_25 = (_24 = axiosError.response) === null || _24 === void 0 ? void 0 : _24.data) === null || _25 === void 0 ? void 0 : _25.errorMessageCode) !== null && _26 !== void 0 ? _26 : 'error.fetch.failed',
                collision: (_29 = (_28 = (_27 = axiosError.response) === null || _27 === void 0 ? void 0 : _27.data) === null || _28 === void 0 ? void 0 : _28.collision) !== null && _29 !== void 0 ? _29 : false,
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.fetch.failed',
        };
    }
});
export const createAccount = (user, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _30, _31, _32, _33, _34, _35, _36, _37, _38;
    if (!user) {
        trackException(new Error('No user to create. Empty.'));
        return {
            success: false,
            errorMessageCode: 'error.data.format',
        };
    }
    try {
        const options = {
            timeout: 10000,
            data: user,
            url: apiBaseUrl.format(),
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        console.log('Sending:', user);
        const response = yield axios(options);
        const { status, data } = response;
        if (data != null && status >= 200 && status < 300) {
            return {
                success: true,
                id: data,
            };
        }
        else {
            return {
                success: false,
                statusCode: status,
                errorMessageCode: data.errorMessageCode,
                collision: data.collision,
            };
        }
    }
    catch (e) {
        trackException(new Error(`Failed to create a new account. ${e}`));
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            console.log('Axios error. Response Status:', (_30 = axiosError.response) === null || _30 === void 0 ? void 0 : _30.status, ' Data:', (_31 = axiosError.response) === null || _31 === void 0 ? void 0 : _31.data);
            return {
                success: false,
                statusCode: (_32 = axiosError.response) === null || _32 === void 0 ? void 0 : _32.status,
                errorMessageCode: (_35 = (_34 = (_33 = axiosError.response) === null || _33 === void 0 ? void 0 : _33.data) === null || _34 === void 0 ? void 0 : _34.errorMessageCode) !== null && _35 !== void 0 ? _35 : 'error.create.failed',
                collision: (_38 = (_37 = (_36 = axiosError.response) === null || _36 === void 0 ? void 0 : _36.data) === null || _37 === void 0 ? void 0 : _37.collision) !== null && _38 !== void 0 ? _38 : false,
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.create.failed',
        };
    }
});
export const confirmEmail = (props, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _39, _40, _41, _42, _43, _44, _45, _46, _47;
    try {
        const options = {
            timeout: 10000,
            data: props,
            url: apiBaseUrl.clone().pathname('confirm/email').format(),
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        console.log('Sending:', props);
        const response = yield axios(options);
        const { status, data } = response;
        if (data != null && status >= 200 && status < 300) {
            return {
                success: true,
            };
        }
        else {
            return {
                success: false,
                statusCode: status,
                errorMessageCode: data.errorMessageCode,
                collision: data.collision,
            };
        }
    }
    catch (e) {
        trackException(new Error(`Failed to confirm email. ${e}`));
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            console.log('Axios error. Response Status:', (_39 = axiosError.response) === null || _39 === void 0 ? void 0 : _39.status, ' Data:', (_40 = axiosError.response) === null || _40 === void 0 ? void 0 : _40.data);
            return {
                success: false,
                statusCode: (_41 = axiosError.response) === null || _41 === void 0 ? void 0 : _41.status,
                errorMessageCode: (_44 = (_43 = (_42 = axiosError.response) === null || _42 === void 0 ? void 0 : _42.data) === null || _43 === void 0 ? void 0 : _43.errorMessageCode) !== null && _44 !== void 0 ? _44 : 'error.update.failed',
                collision: (_47 = (_46 = (_45 = axiosError.response) === null || _45 === void 0 ? void 0 : _45.data) === null || _46 === void 0 ? void 0 : _46.collision) !== null && _47 !== void 0 ? _47 : false,
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.update.failed',
        };
    }
});
export const updateAccount = (user, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _48, _49, _50, _51, _52, _53, _54, _55, _56;
    if (!user) {
        trackException(new Error('Data format error.'));
        return {
            success: false,
            errorMessageCode: 'error.data.format',
        };
    }
    const { id } = user, parameters = __rest(user, ["id"]);
    try {
        const options = {
            timeout: 10000,
            data: parameters,
            url: apiBaseUrl.clone().pathname(user.id).format(),
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        console.log('Sending:', user);
        const response = yield axios(options);
        const { status, data } = response;
        if (data != null && status >= 200 && status < 300) {
            return {
                success: true,
            };
        }
        else {
            return {
                success: false,
                statusCode: status,
                errorMessageCode: data.errorMessageCode,
                collision: data.collision,
            };
        }
    }
    catch (e) {
        trackException(new Error(`Failed to change account. ${e}`));
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            console.log('Axios error. Response Status:', (_48 = axiosError.response) === null || _48 === void 0 ? void 0 : _48.status, ' Data:', (_49 = axiosError.response) === null || _49 === void 0 ? void 0 : _49.data);
            return {
                success: false,
                statusCode: (_50 = axiosError.response) === null || _50 === void 0 ? void 0 : _50.status,
                errorMessageCode: (_53 = (_52 = (_51 = axiosError.response) === null || _51 === void 0 ? void 0 : _51.data) === null || _52 === void 0 ? void 0 : _52.errorMessageCode) !== null && _53 !== void 0 ? _53 : 'error.update.failed',
                collision: (_56 = (_55 = (_54 = axiosError.response) === null || _54 === void 0 ? void 0 : _54.data) === null || _55 === void 0 ? void 0 : _55.collision) !== null && _56 !== void 0 ? _56 : false,
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.update.failed',
        };
    }
});
export const changeAccountEmail = (user, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _57, _58, _59, _60, _61, _62, _63, _64, _65;
    if (!(user === null || user === void 0 ? void 0 : user.id) ||
        !user.email ||
        !isEmail(user.email, { allow_display_name: false })) {
        trackException(new Error('Account id or email not specified correctly.'));
        return {
            success: false,
            errorMessageCode: 'error.data.format',
        };
    }
    try {
        const options = {
            timeout: 10000,
            data: {
                oldEmail: user.oldEmail,
                email: user.email,
            },
            url: apiBaseUrl.clone().pathname(`${user.id}/email/set`).format(),
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        console.log('Sending:', user.email);
        const response = yield axios(options);
        const { status, data } = response;
        if (data != null && status >= 200 && status < 300) {
            return {
                success: true,
            };
        }
        else {
            return {
                success: false,
                statusCode: status,
                errorMessageCode: data.errorMessageCode,
                collision: data.collision,
            };
        }
    }
    catch (e) {
        trackException(new Error(`Failed to change account email. ${e}`));
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            console.log('Axios error. Response Status:', (_57 = axiosError.response) === null || _57 === void 0 ? void 0 : _57.status, ' Data:', (_58 = axiosError.response) === null || _58 === void 0 ? void 0 : _58.data);
            return {
                success: false,
                statusCode: (_59 = axiosError.response) === null || _59 === void 0 ? void 0 : _59.status,
                errorMessageCode: (_62 = (_61 = (_60 = axiosError.response) === null || _60 === void 0 ? void 0 : _60.data) === null || _61 === void 0 ? void 0 : _61.errorMessageCode) !== null && _62 !== void 0 ? _62 : 'error.email.change.failed',
                collision: (_65 = (_64 = (_63 = axiosError.response) === null || _63 === void 0 ? void 0 : _63.data) === null || _64 === void 0 ? void 0 : _64.collision) !== null && _65 !== void 0 ? _65 : false,
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.email.change.failed',
        };
    }
});
export const setAccountEmail = (user, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _66, _67, _68, _69, _70, _71, _72, _73, _74;
    if (!(user === null || user === void 0 ? void 0 : user.id) ||
        !user.email ||
        !isEmail(user.email, { allow_display_name: false })) {
        trackException(new Error('Account id or email not specified correctly.'));
        return {
            success: false,
            errorMessageCode: 'error.data.format',
        };
    }
    try {
        const options = {
            timeout: 10000,
            data: {
                email: user.email,
            },
            url: apiBaseUrl.clone().pathname(`${user.id}/email`).format(),
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        console.log('Sending:', user.email);
        const response = yield axios(options);
        const { status, data } = response;
        if (data != null && status >= 200 && status < 300) {
            return {
                success: true,
            };
        }
        else {
            return {
                success: false,
                statusCode: status,
                errorMessageCode: data.errorMessageCode,
                collision: data.collision,
            };
        }
    }
    catch (e) {
        trackException(new Error(`Failed to change account email. ${e}`));
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            console.log('Axios error. Response Status:', (_66 = axiosError.response) === null || _66 === void 0 ? void 0 : _66.status, ' Data:', (_67 = axiosError.response) === null || _67 === void 0 ? void 0 : _67.data);
            return {
                success: false,
                statusCode: (_68 = axiosError.response) === null || _68 === void 0 ? void 0 : _68.status,
                errorMessageCode: (_71 = (_70 = (_69 = axiosError.response) === null || _69 === void 0 ? void 0 : _69.data) === null || _70 === void 0 ? void 0 : _70.errorMessageCode) !== null && _71 !== void 0 ? _71 : 'error.email.change.failed',
                collision: (_74 = (_73 = (_72 = axiosError.response) === null || _72 === void 0 ? void 0 : _72.data) === null || _73 === void 0 ? void 0 : _73.collision) !== null && _74 !== void 0 ? _74 : false,
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.email.change.failed',
        };
    }
});
export const changeAccountPassword = (props, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _75, _76, _77, _78, _79, _80, _81, _82, _83;
    if (!(props === null || props === void 0 ? void 0 : props.accountId) || !props.password || !props.newPassword) {
        trackException(new Error('Account password or new password not specified correctly.'));
        return {
            success: false,
            errorMessageCode: 'error.data.format',
        };
    }
    try {
        const options = {
            timeout: 10000,
            data: props,
            url: apiBaseUrl.clone().pathname(`${props.accountId}/password`).format(),
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        console.log('Sending:', props);
        const response = yield axios(options);
        const { status, data } = response;
        if (status >= 200 && status < 300 && data.success) {
            return {
                success: true,
            };
        }
        else {
            return {
                success: false,
                statusCode: status,
                errorMessageCode: data.errorMessageCode,
                notFound: data.notFound,
            };
        }
    }
    catch (e) {
        trackException(new Error(`Failed to change account password. ${e}`));
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            console.log('Axios error. Response Status:', (_75 = axiosError.response) === null || _75 === void 0 ? void 0 : _75.status, ' Data:', (_76 = axiosError.response) === null || _76 === void 0 ? void 0 : _76.data);
            return {
                success: false,
                statusCode: (_77 = axiosError.response) === null || _77 === void 0 ? void 0 : _77.status,
                errorMessageCode: (_80 = (_79 = (_78 = axiosError.response) === null || _78 === void 0 ? void 0 : _78.data) === null || _79 === void 0 ? void 0 : _79.errorMessageCode) !== null && _80 !== void 0 ? _80 : 'error.email.change.failed',
                notFound: (_83 = (_82 = (_81 = axiosError.response) === null || _81 === void 0 ? void 0 : _81.data) === null || _82 === void 0 ? void 0 : _82.notFound) !== null && _83 !== void 0 ? _83 : false,
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.email.change.failed',
        };
    }
});
export const setAccountPassword = (props, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _84, _85, _86, _87, _88, _89, _90, _91, _92;
    if (!(props === null || props === void 0 ? void 0 : props.accountId) || !props.newPassword) {
        trackException(new Error('Account new password not specified correctly.'));
        return {
            success: false,
            errorMessageCode: 'error.data.format',
        };
    }
    try {
        const options = {
            timeout: 10000,
            data: props,
            url: apiBaseUrl.clone().pathname(`${props.accountId}/password`).format(),
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        console.log('Sending:', props);
        const response = yield axios(options);
        const { status, data } = response;
        console.log('Password status:', status);
        if (status >= 200 && status < 300) {
            return {
                success: true,
            };
        }
        else {
            return {
                success: false,
                statusCode: status,
                errorMessageCode: data.errorMessageCode,
                notFound: data.notFound,
            };
        }
    }
    catch (e) {
        trackException(new Error(`Failed to set account password. ${e}`));
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            console.log('Axios error. Response Status:', (_84 = axiosError.response) === null || _84 === void 0 ? void 0 : _84.status, ' Data:', (_85 = axiosError.response) === null || _85 === void 0 ? void 0 : _85.data);
            return {
                success: false,
                statusCode: (_86 = axiosError.response) === null || _86 === void 0 ? void 0 : _86.status,
                errorMessageCode: (_89 = (_88 = (_87 = axiosError.response) === null || _87 === void 0 ? void 0 : _87.data) === null || _88 === void 0 ? void 0 : _88.errorMessageCode) !== null && _89 !== void 0 ? _89 : 'error.email.change.failed',
                notFound: (_92 = (_91 = (_90 = axiosError.response) === null || _90 === void 0 ? void 0 : _90.data) === null || _91 === void 0 ? void 0 : _91.notFound) !== null && _92 !== void 0 ? _92 : false,
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.email.change.failed',
        };
    }
});
export const deleteAccount = (id, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _93, _94, _95, _96, _97, _98, _99;
    try {
        const options = {
            timeout: 10000,
            data: '',
            url: apiBaseUrl.clone().pathname(id).format(),
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        const response = yield axios(options);
        const { status, data } = response;
        if (data != null && status >= 200 && status < 300) {
            return {
                success: true,
            };
        }
        else {
            return {
                success: false,
                statusCode: status,
                errorMessageCode: (_93 = data.errorMessageCode) !== null && _93 !== void 0 ? _93 : 'error.deletion.failed',
                notFound: data.notFound,
            };
        }
    }
    catch (e) {
        trackException(new Error(`Failed to delete account. ${e}`));
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            console.log('Axios error. Response Status:', (_94 = axiosError.response) === null || _94 === void 0 ? void 0 : _94.status, ' Data:', (_95 = axiosError.response) === null || _95 === void 0 ? void 0 : _95.data);
            return {
                success: false,
                statusCode: (_96 = axiosError.response) === null || _96 === void 0 ? void 0 : _96.status,
                errorMessageCode: (_99 = (_98 = (_97 = axiosError.response) === null || _97 === void 0 ? void 0 : _97.data) === null || _98 === void 0 ? void 0 : _98.errorMessageCode) !== null && _99 !== void 0 ? _99 : 'error.deletion.failed',
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.deletion.failed',
        };
    }
});
export const lockAccount = (id, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _100, _101, _102, _103, _104, _105, _106;
    try {
        const options = {
            timeout: 10000,
            data: '',
            url: apiBaseUrl.clone().pathname(`${id}/lock`).format(),
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        const response = yield axios(options);
        const { status, data } = response;
        if (data != null && status >= 200 && status < 300) {
            return {
                success: true,
            };
        }
        else {
            return {
                success: false,
                statusCode: status,
                errorMessageCode: (_100 = data.errorMessageCode) !== null && _100 !== void 0 ? _100 : 'error.lock.failed',
                notFound: data.notFound,
            };
        }
    }
    catch (e) {
        trackException(new Error(`Failed to lock account. ${e}`));
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            console.log('Axios error. Response Status:', (_101 = axiosError.response) === null || _101 === void 0 ? void 0 : _101.status, ' Data:', (_102 = axiosError.response) === null || _102 === void 0 ? void 0 : _102.data);
            return {
                success: false,
                statusCode: (_103 = axiosError.response) === null || _103 === void 0 ? void 0 : _103.status,
                errorMessageCode: (_106 = (_105 = (_104 = axiosError.response) === null || _104 === void 0 ? void 0 : _104.data) === null || _105 === void 0 ? void 0 : _105.errorMessageCode) !== null && _106 !== void 0 ? _106 : 'error.lock.failed',
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.lock.failed',
        };
    }
});
export const unlockAccount = (id, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _107, _108, _109, _110, _111, _112, _113;
    try {
        const options = {
            timeout: 10000,
            data: '',
            url: apiBaseUrl.clone().pathname(`${id}/unlock`).format(),
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        const response = yield axios(options);
        const { status, data } = response;
        if (data != null && status >= 200 && status < 300) {
            return {
                success: true,
            };
        }
        else {
            return {
                success: false,
                statusCode: status,
                errorMessageCode: (_107 = data.errorMessageCode) !== null && _107 !== void 0 ? _107 : 'error.unlock.failed',
                notFound: data.notFound,
            };
        }
    }
    catch (e) {
        trackException(new Error(`Failed to unlock account. ${e}`));
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            console.log('Axios error. Response Status:', (_108 = axiosError.response) === null || _108 === void 0 ? void 0 : _108.status, ' Data:', (_109 = axiosError.response) === null || _109 === void 0 ? void 0 : _109.data);
            return {
                success: false,
                statusCode: (_110 = axiosError.response) === null || _110 === void 0 ? void 0 : _110.status,
                errorMessageCode: (_113 = (_112 = (_111 = axiosError.response) === null || _111 === void 0 ? void 0 : _111.data) === null || _112 === void 0 ? void 0 : _112.errorMessageCode) !== null && _113 !== void 0 ? _113 : 'error.unlock.failed',
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.unlock.failed',
        };
    }
});
export const lockCrewApplication = (id, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _114, _115, _116, _117, _118, _119, _120;
    try {
        const options = {
            timeout: 10000,
            data: '',
            url: apiBaseUrl.clone().pathname(`${id}/crew/lock`).format(),
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        const response = yield axios(options);
        const { status, data } = response;
        if (data != null && status >= 200 && status < 300) {
            return {
                success: true,
            };
        }
        else {
            return {
                success: false,
                statusCode: status,
                errorMessageCode: (_114 = data.errorMessageCode) !== null && _114 !== void 0 ? _114 : 'error.lock.failed',
                notFound: data.notFound,
            };
        }
    }
    catch (e) {
        trackException(new Error(`Failed to lock account crew applications. ${e}`));
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            console.log('Axios error. Response Status:', (_115 = axiosError.response) === null || _115 === void 0 ? void 0 : _115.status, ' Data:', (_116 = axiosError.response) === null || _116 === void 0 ? void 0 : _116.data);
            return {
                success: false,
                statusCode: (_117 = axiosError.response) === null || _117 === void 0 ? void 0 : _117.status,
                errorMessageCode: (_120 = (_119 = (_118 = axiosError.response) === null || _118 === void 0 ? void 0 : _118.data) === null || _119 === void 0 ? void 0 : _119.errorMessageCode) !== null && _120 !== void 0 ? _120 : 'error.lock.failed',
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.lock.failed',
        };
    }
});
export const unlockCrewApplication = (id, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _121, _122, _123, _124, _125, _126, _127;
    try {
        const options = {
            timeout: 10000,
            data: '',
            url: apiBaseUrl.clone().pathname(`${id}/crew/unlock`).format(),
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        const response = yield axios(options);
        const { status, data } = response;
        if (data != null && status >= 200 && status < 300) {
            return {
                success: true,
            };
        }
        else {
            return {
                success: false,
                statusCode: status,
                errorMessageCode: (_121 = data.errorMessageCode) !== null && _121 !== void 0 ? _121 : 'error.unlock.failed',
                notFound: data.notFound,
            };
        }
    }
    catch (e) {
        trackException(new Error(`Failed to unlock account crew applications. ${e}`));
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            console.log('Axios error. Response Status:', (_122 = axiosError.response) === null || _122 === void 0 ? void 0 : _122.status, ' Data:', (_123 = axiosError.response) === null || _123 === void 0 ? void 0 : _123.data);
            return {
                success: false,
                statusCode: (_124 = axiosError.response) === null || _124 === void 0 ? void 0 : _124.status,
                errorMessageCode: (_127 = (_126 = (_125 = axiosError.response) === null || _125 === void 0 ? void 0 : _125.data) === null || _126 === void 0 ? void 0 : _126.errorMessageCode) !== null && _127 !== void 0 ? _127 : 'error.unlock.failed',
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.unlock.failed',
        };
    }
});
export const setAccountRole = (props, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _128, _129, _130, _131, _132, _133, _134;
    try {
        const { accountId } = props, args = __rest(props, ["accountId"]);
        const options = {
            timeout: 10000,
            data: args,
            url: apiBaseUrl.clone().pathname(`${accountId}/role`).format(),
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        const response = yield axios(options);
        const { status, data } = response;
        if (data != null && status >= 200 && status < 300) {
            return {
                success: true,
            };
        }
        else {
            return {
                success: false,
                statusCode: status,
                errorMessageCode: (_128 = data.errorMessageCode) !== null && _128 !== void 0 ? _128 : 'error.change.failed',
                notFound: data.notFound,
            };
        }
    }
    catch (e) {
        trackException(new Error(`Failed to change role. ${e}`));
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            console.log('Axios error. Response Status:', (_129 = axiosError.response) === null || _129 === void 0 ? void 0 : _129.status, ' Data:', (_130 = axiosError.response) === null || _130 === void 0 ? void 0 : _130.data);
            return {
                success: false,
                statusCode: (_131 = axiosError.response) === null || _131 === void 0 ? void 0 : _131.status,
                errorMessageCode: (_134 = (_133 = (_132 = axiosError.response) === null || _132 === void 0 ? void 0 : _132.data) === null || _133 === void 0 ? void 0 : _133.errorMessageCode) !== null && _134 !== void 0 ? _134 : 'error.change.failed',
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.change.failed',
        };
    }
});
export const applyCrew = (id, params, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _135, _136, _137, _138, _139, _140, _141;
    try {
        const options = {
            timeout: 10000,
            data: params.crewApplication,
            url: apiBaseUrl
                .clone()
                .pathname(`${id}/crew`)
                .query({ lang: params.langCode })
                .format(),
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        const response = yield axios(options);
        const { status, data } = response;
        if (data != null && status >= 200 && status < 300) {
            return {
                success: true,
            };
        }
        else {
            return {
                success: false,
                statusCode: status,
                errorMessageCode: (_135 = data.errorMessageCode) !== null && _135 !== void 0 ? _135 : 'error.send.failed',
                notFound: data.notFound,
            };
        }
    }
    catch (e) {
        trackException(new Error(`Failed to create crew application. ${e}`));
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            console.log('Axios error. Response Status:', (_136 = axiosError.response) === null || _136 === void 0 ? void 0 : _136.status, ' Data:', (_137 = axiosError.response) === null || _137 === void 0 ? void 0 : _137.data);
            return {
                success: false,
                statusCode: (_138 = axiosError.response) === null || _138 === void 0 ? void 0 : _138.status,
                errorMessageCode: (_141 = (_140 = (_139 = axiosError.response) === null || _139 === void 0 ? void 0 : _139.data) === null || _140 === void 0 ? void 0 : _140.errorMessageCode) !== null && _141 !== void 0 ? _141 : 'error.send.failed',
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.send.failed',
        };
    }
});
export const applyPress = (id, params, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _142, _143, _144, _145, _146, _147, _148;
    try {
        const options = {
            timeout: 10000,
            data: params.pressApplication,
            url: apiBaseUrl
                .clone()
                .pathname(`${id}/press`)
                .query({ lang: params.langCode })
                .format(),
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        const response = yield axios(options);
        const { status, data } = response;
        if (data != null && status >= 200 && status < 300) {
            return {
                success: true,
            };
        }
        else {
            return {
                success: false,
                statusCode: status,
                errorMessageCode: (_142 = data.errorMessageCode) !== null && _142 !== void 0 ? _142 : 'error.send.failed',
                notFound: data.notFound,
            };
        }
    }
    catch (e) {
        trackException(new Error(`Failed to create press application. ${e}`));
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            console.log('Axios error. Response Status:', (_143 = axiosError.response) === null || _143 === void 0 ? void 0 : _143.status, ' Data:', (_144 = axiosError.response) === null || _144 === void 0 ? void 0 : _144.data);
            return {
                success: false,
                statusCode: (_145 = axiosError.response) === null || _145 === void 0 ? void 0 : _145.status,
                errorMessageCode: (_148 = (_147 = (_146 = axiosError.response) === null || _146 === void 0 ? void 0 : _146.data) === null || _147 === void 0 ? void 0 : _147.errorMessageCode) !== null && _148 !== void 0 ? _148 : 'error.send.failed',
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.send.failed',
        };
    }
});
export const setAreaManagerAreas = (id, params, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _149, _150, _151, _152, _153, _154, _155;
    try {
        const options = {
            timeout: 10000,
            data: {
                areas: params.areas,
            },
            url: apiBaseUrl
                .clone()
                .pathname(`${id}/crew/managedareas`)
                .query({ lang: params.langCode })
                .format(),
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        const response = yield axios(options);
        const { status, data } = response;
        if (data != null && status >= 200 && status < 300) {
            return {
                success: true,
            };
        }
        else {
            return {
                success: false,
                statusCode: status,
                errorMessageCode: (_149 = data.errorMessageCode) !== null && _149 !== void 0 ? _149 : 'error.update.failed',
                notFound: data.notFound,
            };
        }
    }
    catch (e) {
        trackException(new Error(`Failed to crew managed areas. ${e}`));
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            console.log('Axios error. Response Status:', (_150 = axiosError.response) === null || _150 === void 0 ? void 0 : _150.status, ' Data:', (_151 = axiosError.response) === null || _151 === void 0 ? void 0 : _151.data);
            return {
                success: false,
                statusCode: (_152 = axiosError.response) === null || _152 === void 0 ? void 0 : _152.status,
                errorMessageCode: (_155 = (_154 = (_153 = axiosError.response) === null || _153 === void 0 ? void 0 : _153.data) === null || _154 === void 0 ? void 0 : _154.errorMessageCode) !== null && _155 !== void 0 ? _155 : 'error.update.failed',
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.update.failed',
        };
    }
});
export const setCrewAreas = (id, params, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _156, _157, _158, _159, _160, _161, _162;
    try {
        const options = {
            timeout: 10000,
            data: {
                areas: params.areas,
            },
            url: apiBaseUrl.clone().pathname(`${id}/crew/areas`).format(),
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        const response = yield axios(options);
        const { status, data } = response;
        if (data != null && status >= 200 && status < 300) {
            return {
                success: true,
            };
        }
        else {
            return {
                success: false,
                statusCode: status,
                errorMessageCode: (_156 = data.errorMessageCode) !== null && _156 !== void 0 ? _156 : 'error.update.failed',
                notFound: data.notFound,
            };
        }
    }
    catch (e) {
        trackException(new Error(`Failed to change crew areas. ${e}`));
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            console.log('Axios error. Response Status:', (_157 = axiosError.response) === null || _157 === void 0 ? void 0 : _157.status, ' Data:', (_158 = axiosError.response) === null || _158 === void 0 ? void 0 : _158.data);
            return {
                success: false,
                statusCode: (_159 = axiosError.response) === null || _159 === void 0 ? void 0 : _159.status,
                errorMessageCode: (_162 = (_161 = (_160 = axiosError.response) === null || _160 === void 0 ? void 0 : _160.data) === null || _161 === void 0 ? void 0 : _161.errorMessageCode) !== null && _162 !== void 0 ? _162 : 'error.update.failed',
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.update.failed',
        };
    }
});
export const getEquipmentListForAccount = (id, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _163, _164, _165, _166, _167, _168, _169, _170, _171;
    try {
        const options = {
            timeout: 10000,
            data: '',
            url: apiBaseUrl.clone().pathname(`${id}/equipment`).format(),
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        const response = yield axios(options);
        const { status, data } = response;
        if (data != null && status >= 200 && status < 300) {
            return {
                success: true,
                data: data,
            };
        }
        else {
            return {
                success: false,
                statusCode: status,
                errorMessageCode: 'error.fetch.failed',
            };
        }
    }
    catch (e) {
        trackException(new Error(`Failed to get areas. ${e}`));
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            console.log('Axios error. Response Status:', (_163 = axiosError.response) === null || _163 === void 0 ? void 0 : _163.status, ' Data:', (_164 = axiosError.response) === null || _164 === void 0 ? void 0 : _164.data);
            return {
                success: false,
                statusCode: (_165 = axiosError.response) === null || _165 === void 0 ? void 0 : _165.status,
                errorMessageCode: (_168 = (_167 = (_166 = axiosError.response) === null || _166 === void 0 ? void 0 : _166.data) === null || _167 === void 0 ? void 0 : _167.errorMessageCode) !== null && _168 !== void 0 ? _168 : 'error.fetch.failed',
                collision: (_171 = (_170 = (_169 = axiosError.response) === null || _169 === void 0 ? void 0 : _169.data) === null || _170 === void 0 ? void 0 : _170.collision) !== null && _171 !== void 0 ? _171 : false,
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.fetch.failed',
        };
    }
});
export const saveCrewDetails = (accountId, crewDetails, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _172, _173, _174, _175;
    try {
        const options = {
            timeout: 10000,
            data: crewDetails,
            url: apiBaseUrl.clone().pathname(`${accountId}/crew`).format(),
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        const response = yield axios(options);
        const { status, data } = response;
        if (data != null && status >= 200 && status < 300) {
            return {
                success: true,
            };
        }
        else {
            return {
                success: false,
                statusCode: status,
                errorMessageCode: data.errorMessageCode || 'error.update.failed',
            };
        }
    }
    catch (e) {
        trackException(new Error(`Failed to save crew details. ${e}`));
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            return {
                success: false,
                statusCode: (_172 = axiosError.response) === null || _172 === void 0 ? void 0 : _172.status,
                errorMessageCode: (_175 = (_174 = (_173 = axiosError.response) === null || _173 === void 0 ? void 0 : _173.data) === null || _174 === void 0 ? void 0 : _174.errorMessageCode) !== null && _175 !== void 0 ? _175 : 'error.update.failed',
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.update.failed',
        };
    }
});
export const savePressDetails = (accountId, pressDetails, trackException) => __awaiter(void 0, void 0, void 0, function* () {
    var _176, _177, _178, _179;
    try {
        const options = {
            timeout: 10000,
            data: pressDetails,
            url: apiBaseUrl.clone().pathname(`${accountId}/press`).format(),
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        const response = yield axios(options);
        const { status, data } = response;
        if (data != null && status >= 200 && status < 300) {
            return {
                success: true,
            };
        }
        else {
            return {
                success: false,
                statusCode: status,
                errorMessageCode: data.errorMessageCode || 'error.update.failed',
            };
        }
    }
    catch (e) {
        trackException(new Error(`Failed to save press details. ${e}`));
        if (axios.isAxiosError(e)) {
            const axiosError = e;
            console.log('Axios error. Code:', axiosError.code, ' Status:', axiosError.status);
            return {
                success: false,
                statusCode: (_176 = axiosError.response) === null || _176 === void 0 ? void 0 : _176.status,
                errorMessageCode: (_179 = (_178 = (_177 = axiosError.response) === null || _177 === void 0 ? void 0 : _177.data) === null || _178 === void 0 ? void 0 : _178.errorMessageCode) !== null && _179 !== void 0 ? _179 : 'error.update.failed',
            };
        }
        return {
            success: false,
            errorMessageCode: 'error.update.failed',
        };
    }
});
